import styled from "styled-components";
import Threshold from "constants/threshold";
import Colors from "constants/colors";

export const CourseBlock = styled.div<{ srcImage?: string }>`
  width: 100%;
  height: 200px;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.0001) 45.72%,
      rgba(0, 0, 0, 0.701596) 100%
    ),
    url(${({ srcImage }) => srcImage}) center center / cover no-repeat;

  @media (min-width: ${Threshold.phone}) {
    max-width: 500px;
    height: 270px;
    transition-duration: 0.3s;
    &:hover {
      transform: scale(1.07);
    }
  }
`;
export const CourseContainer = styled.a`
  display: block;
  position: relative;
  max-width: 330px;
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  cursor: pointer;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  color: ${Colors.black};
  text-decoration: none;

  @media (min-width: ${Threshold.phone}) {
    width: 95%;
    max-width: 500px;
    height: 270px;
    margin-bottom: 40px;
  }
`;

export const CourseTitle = styled.h4`
  font-weight: bold;
  font-size: 16px;
  color: ${Colors.white};
  margin: 0;

  @media (min-width: ${Threshold.phone}) {
    font-weight: bold;
    font-size: 35px;
  }
`;

export const CourseDescription = styled.span`
  font-size: 14px;
  color: ${Colors.white};

  @media (min-width: ${Threshold.phone}) {
    font-weight: 500;
    font-size: 16px;
    line-height: 35px;
  }
`;

export const CourseText = styled.div`
  position: absolute;
  left: 8%;
  bottom: 10%;
  margin-bottom: 0;
`;
